import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import Reveal from "@/components/base/Reveal";

export default function CategoryGrid() {
  return (
    <section id="categories" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="flex items-center gap-2 text-xs tracking-[0.3em] text-accent-500">
              <i className="ri-layout-grid-line" />
              TOPIC CATEGORIES
            </span>
            <h2 className="heading-serif mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
              按你感兴趣的方向找话题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              深夜的瓜分很多种，有人关注热搜人设，有人只关心作品本身。选一个方向，直接从最热闹的讨论区开始。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, index) => (
            <Reveal key={cat.id} delay={index * 50}>
              <Link
                to={`/topics?cat=${cat.id}`}
                className="group flex h-full flex-col rounded-lg border border-background-200/80 bg-background-100 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-accent-500/60"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-500">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <h3 className="heading-serif mt-4 text-lg font-bold text-foreground-950 transition-colors group-hover:text-accent-500">
                  {cat.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">{cat.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                  <span>{cat.count} 个话题</span>
                  <span className="flex items-center gap-1 text-accent-500">
                    进入
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}

          <Reveal delay={350}>
            <Link
              to="/topics"
              className="group flex h-full min-h-[200px] flex-col items-center justify-center rounded-lg border border-dashed border-primary-400/50 bg-primary-50/40 p-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-500"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-add-line text-2xl" />
              </span>
              <h3 className="heading-serif mt-4 text-base font-bold text-foreground-950">浏览全部话题</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-500">
                不挑方向，直接看广场上最热闹的讨论
              </p>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}